// TODO - convert keys to caps
export default {
  wild: '*',
  root: '/',
  signIn: 'sign-in',
  home: 'home',
  overview: 'overview',
  signUp: 'sign-up',
  dashboard: 'dashboard',
  workflow: 'workflow',
  workflows: 'workflows',
  contacts: 'contacts',
  templates: 'templates',
  account: 'account',
  profile: 'profile',
  signatures: 'signatures',
  security: 'security',
  provisions: 'provisions',
  stamps: 'stamps',
  invitations: 'invitations',
  documents: 'documents',
  document: 'document',
  shortcuts: 'shortcuts',
  design: 'design',
  series: 'series',
  groups: 'groups',
  settings: 'settings',
  wallet: 'wallet',
  department: 'department',
  admin: 'admin',
  notifications: 'notifications',
  activity: 'activity',
  ebgNotifications: 'ebg-notifications',
  pending: 'pending',
  reviewed: 'reviewed',
  archive: 'archive',
  termsConditions: 'terms-conditions',
  privacyPolicy: 'privacy-policy',
  all: 'all',
  sent: 'sent',
  received: 'received',
  processing: 'processing',
  cc: 'cc',
  drafts: 'drafts',
  actionRequired: 'action-required',
  waitingForOthers: 'waiting-for-others',
  expiringSoon: 'expiring-soon',
  failed: 'failed',
  neslFailureCases: 'nesl-failure-cases',
  expired: 'expired',
  completed: 'completed',
  filters: 'filters',
  colonId: ':id',
  favourites: 'favourites',
  customFilter: 'custom/:id',
  custom: 'custom',
  details: 'details',
  purchases: 'purchases',
  folder: 'folder/:id',
  rejected: 'rejected',
  accounts: 'accounts',
  api: 'api',
  esignAndSeal: 'esign-and-seal',
  automation: 'automation',
  purchase: 'purchase',
  purchaseHistory: 'purchase-history',
  invoices: 'invoices',
  taxInvoices: 'tax-invoices',
  proformaInvoices: 'proforma-invoices',
  consumptionHistory: 'consumption-history',
  billingProfiles: 'billing-profiles',
  lowBalanceConfigs: 'low-balance-configs',
  branding: 'branding',
  eSignature: 'esignature',
  stamp: 'stamp',
  documentConfigs: 'document-configs',
  inviteeConfigs: 'invitee-configs',
  neslEsignConfig: 'nesl-esign-configs',
  eventReviewers: 'event-reviewers',
  neslProfiles: 'nesl-profiles',
  sftp: 'sftp',
  users: 'users',
  newUsers: 'new-users',
  departments: 'departments',
  dt: 'dt',
  pdfEditor: 'pdf-editor',
  addFields: 'add-fields',
  viewFields: 'view-fields',
  previewPdf: 'preview-pdf',
  esign: 'esign',
  paymentCollect: 'payment-collect',
  workflowBuilderConfig: 'workflow-builder-config',
  integrationConfigs: 'integration-configs',
  public: 'public',
  authenticate: 'authenticate',
  sso: 'sso',
  callback: 'callback',
  create: 'create',
  v3: 'v3',
  v4: 'v4',
  edit: 'edit',
  run: 'run',
  docs: 'docs',
  packs: 'packs',
  customFields: 'custom-fields',
  draft: 'draft',
  published: 'published',
  reports: 'reports',
  bulkSigning: 'bulk-signing',
  list: 'list',
};
